import React, { FC, useState } from "react";
import { defineMessages, useIntl } from "react-intl";
import "./partnerInformationModal.scss";
import InputForm from "@app/neva/components/partnerInformationModal/components/inputForm";
import DrawerModal from "@app/neva/components/drawerModal/drawerModal";
import { ButtonTypes } from "@app/neva/models";

const CLOSE_MODAL_DELAY_TIMEOUT = 300;

const messages = defineMessages({
  enterPartnerInformationTitle: {
    id: "enterPartnerInformationTitle",
    defaultMessage: "Please enter the following information for your partner.",
  },
  editPartnerInformationTitle: {
    id: "editPartnerInformationTitle",
    defaultMessage: "Please edit the following information for your partner.",
  },
});

interface Props {
  onClose: () => void;
  messageId: string;
  type: string;
}

export const PartnerInformationModal: FC<Props> = ({
  onClose,
  messageId,
  type,
}) => {
  const intl = useIntl();
  const [showSuccessScreen, setShowSuccessScreen] = useState(false);
  const handleCloseModal = () => {
    setTimeout(() => onClose(), CLOSE_MODAL_DELAY_TIMEOUT);
  };

  const getPartnerInformationTitle = () => {
    return intl.formatMessage(
      type === ButtonTypes.ENTER_PARTNER_INFORMATION
        ? messages.enterPartnerInformationTitle
        : messages.editPartnerInformationTitle
    );
  };

  return (
    <DrawerModal
      closeHandler={handleCloseModal}
      showSuccessScreen={showSuccessScreen}
    >
      <div className="partner-information-modal__content">
        <h3 className="partner-information-modal__title">
          {getPartnerInformationTitle()}
        </h3>
        <div className="partner-information-modal__form">
          <InputForm
            setShowSuccessScreen={setShowSuccessScreen}
            messageId={messageId}
            type={type}
          />
        </div>
      </div>
    </DrawerModal>
  );
};

export default PartnerInformationModal;
